import React from "react";
import PolicyPage from "./PolicyPage";
import { policyDocuments } from "../Datas/policyData";

function Privacy() {
  return <PolicyPage document={policyDocuments.privacy} />;
}

export default Privacy;
